import { ELinkManagementTabs } from '@organisms/Enterprise/LinksManagement/enums';

export enum LinkManagementCategory {
  CyberLockers = 'Cyber Lockers',
  StreamOnDemand = 'Stream On Demand',
  LiveStreams = 'Streaming',
  Torrents = 'Torrents',
  SocialMedia = 'Social Media',
  ImpersonationViolation = 'Impersonation Violation',
  PiracyViolation = 'Piracy Violation',
  DeepFakeIdentified = 'Deep Fake Identified',
  Counterfeit = 'Counterfeit',
  CopyrightViolation = 'Copyright Violation',
  TrademarkViolation = 'Trademark Violation',
  DesignViolation = 'Design Violation',
  PolicyViolation = 'Policy Violation',
  FalsePositive = 'False Positive',
}

export const LinkManagementCategoryMapper = {
  [LinkManagementCategory.CyberLockers]: 'Cyber Lockers',
  [LinkManagementCategory.StreamOnDemand]: 'Stream On Demand',
  [LinkManagementCategory.LiveStreams]: 'Live Streams',
  [LinkManagementCategory.Torrents]: 'Torrents',
  [LinkManagementCategory.SocialMedia]: 'Social Media',
  [LinkManagementCategory.ImpersonationViolation]: 'Impersonation Violation',
  [LinkManagementCategory.PiracyViolation]: 'Piracy Violation',
  [LinkManagementCategory.DeepFakeIdentified]: 'Deep Fake Identified',
  [LinkManagementCategory.Counterfeit]: 'Counterfeit',
  [LinkManagementCategory.CopyrightViolation]: 'Copyright Violation',
  [LinkManagementCategory.TrademarkViolation]: 'Trademark Violation',
  [LinkManagementCategory.DesignViolation]: 'Design Violation',
  [LinkManagementCategory.PolicyViolation]: 'Policy Violation',
  [LinkManagementCategory.FalsePositive]: 'False Positive',
};

export interface ITableLinksManagement {
  id: string;
  url: string;
  assetId: string;
  assetTitle: string;
  status: number;
  category: number;
  createdAt: string;
  updatedAt: string;
  identifiedType: number;
  priority: number;
  country: string;
  region: string;
  domain: {
    name: string;
    metadata: {
      createdAt: string;
      ipAddresses: string[];
      nameServers: string[];
    };
  };
  hosting: string;
  sourceType: number | null;
  product: object;
  isInternal: boolean | null;
  verifiedAt: string | null;
  enforcedAt: string | null;
  resolvedAt: string | null;
  archivedAt: string | null;
}

export interface IEnterpriseLinksManagementTableProps {
  selectedTab: ELinkManagementTabs;
}

export interface IPreSelectedFiltesrLinkManagement {
  id: string;
  createdFrom?: string;
  createdTo?: string;
  url?: string;
  priority?: string;
  status?: string;
  identifiedType?: string;
  assetId?: string;
}
